<template>
  <q-table
    v-model:pagination="pagination"
    title=""
    :rows="payments"
    :columns="columnDefinition"
    :loading="loading"
    row-key="id"
    :rows-per-page-options="[]"
    @request="onRequest"
  >
    <template #body="props">
      <q-tr :props="props">
        <q-td key="timestamp" :props="props">
          {{ timestuff.humanReadableDate(props.row.timestamp) }}
        </q-td>
        <q-td key="subscriptionTitle" :props="props">
          {{ props.row.subscriptionTitle }}
        </q-td>
        <q-td key="price" :props="props">
          {{ props.row.price }}
        </q-td>
        <q-td key="type" :props="props">
          {{ mappers.paymentTypeMapper(props.row.paymentType) }}
        </q-td>
      </q-tr>
    </template>
  </q-table>
</template>

<script>
import { ref, toRefs, watch } from 'vue'
import axios from 'axios'
import * as columns from '../../utils/columns'
import * as mappers from '../../utils/mapper'
import * as timestuff from '../../utils/timetravel'
export default {
  props: {
    start: String,
    end: String,
  },
  setup(props) {
    const loading = ref(false)
    const pagination = ref({
      page: 1,
      rowsPerPage: 10,
      rowsNumber: 0,
    })
    const payments = ref([])
    const columnDefinition = columns.PAYMENT_COLUMNS
    let { start, end } = toRefs(props)

    function fetchFromServer(page, size) {
      loading.value = true
      axios
        .get(
          `/purchase?start=${start.value}&end=${end.value}&page=${page}&size=${size}`
        )
        .then((response) => {
          payments.value = response.data
        })
        .finally(() => {
          loading.value = false
        })
    }

    function getRowsNumberCount() {
      axios
        .get(`/purchase/count?start=${start.value}&end=${end.value}`)
        .then((response) => {
          pagination.value.rowsNumber = response.data
          pagination.value.page = 1
        })
    }

    function onRequest(props) {
      const { page, rowsPerPage } = props.pagination
      fetchFromServer(page - 1, rowsPerPage)
      pagination.value.page = page
      pagination.value.rowsPerPage = rowsPerPage
    }

    watch(start, (selection, prevSelection) => {
      console.log(
        'Starting date changed from ' + prevSelection + ' to ' + selection
      )
      getRowsNumberCount()
      fetchFromServer(0, 10)
    })

    watch(end, (selection, prevSelection) => {
      console.log(
        'Ending date changed from ' + prevSelection + ' to ' + selection
      )
      getRowsNumberCount()
      fetchFromServer(0, 10)
    })

    return {
      loading,
      columnDefinition,
      pagination,
      payments,
      mappers,
      timestuff,
      fetchFromServer,
      getRowsNumberCount,
      onRequest,
    }
  },
  created() {
    this.getRowsNumberCount()
    this.fetchFromServer(0, 10)
  },
}
</script>
